// Will be the wrapper of the 'useImageManagerUI' hook so as to be called by trigger

// Import reusable components
import ImageManagerModal from "./ImageManagerModal";

// Import hooks and utils
import { useImageManagerUI } from "@/hooks/useImageManagerUI";

export default function GlobalImageManager() {
    const { isOpen } = useImageManagerUI();

    if (!isOpen) return null;

    return <ImageManagerModal />;
};